import { render, staticRenderFns } from "./inputHeader.vue?vue&type=template&id=5cfefdc8&scoped=true"
import script from "./inputHeader.vue?vue&type=script&lang=js"
export * from "./inputHeader.vue?vue&type=script&lang=js"
import style0 from "./inputHeader.vue?vue&type=style&index=0&id=5cfefdc8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cfefdc8",
  null
  
)

export default component.exports